module.exports = __webpack_public_path__ + "img/p1-m@2x.d7d55fe1.jpg";